// Project numbers carry the owning company in their first three digits:
// 100 => Clayco, 240 => SEI. Anything else falls back to Clayco.

export const PROJECT_COMPANY_CLAYCO = 'Clayco';
export const PROJECT_COMPANY_SEI = 'SEI';

export function getProjectCompany(projectNumber) {
  const prefix = String(projectNumber ?? '').replace(/\D/g, '').slice(0, 3);
  return prefix === '240' ? PROJECT_COMPANY_SEI : PROJECT_COMPANY_CLAYCO;
}

// Dropdown label for a project option, tagged so SEI and Clayco jobs are
// distinguishable in the same list e.g. "[SEI] Project X (240123)".
export function buildProjectOptionLabel(projectName, projectNumber) {
  const name = String(projectName || '').trim();
  const number = String(projectNumber || '').trim();
  const body = name ? `${name}${number ? ` (${number})` : ''}` : number;
  return `[${getProjectCompany(number)}] ${body}`.trim();
}
